export const model = {
    id: null,
    address: "",
    web: "",
    email: "",
    number: "",
};